module.exports = __webpack_public_path__ + "img/q.dac84fba.jpg";